import React from "react";

import ContentAdmin from "./ContentAdmin";

const Admin = () => {
  return (
    <>
      <ContentAdmin />
    </>
  );
};

export default Admin;
